import { useLocation } from 'react-router-dom'

const Location = () => {
  const location = useLocation()
  return location
}

export default Location